import React, { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import Card from 'components/Layout/Card'
import PageHeader from 'components/Layout/PageHeader'
import api from 'api'
import { ReactRouterParams } from 'types/various'
import AgencyTabs from '../AgencyTabs'
import DispositionsList from './DispositionsList'
import './AgencyDispositions.scss'

const AgencyDispositions: React.FC = () => {
  const { t } = useTranslation()
  const { id } = useParams<ReactRouterParams>()
  const [agencyName, setAgencyName] = useState<string>('')

  useEffect(() => {
    if (!id) {
      return
    }

    api.agency
      .getAgency(id)
      .then(res => setAgencyName(res.data.node.name))
      .catch(() => void {})
  }, [id])

  if (!id) {
    return null
  }

  return (
    <>
      <PageHeader>
        {t('agencies.form.editAgency')}
        {agencyName && `: ${agencyName}`}
      </PageHeader>

      <AgencyTabs agencyId={id} />

      <Card className='AgencyDispositions'>
        <DispositionsList agencyId={id} />
      </Card>
    </>
  )
}

export default AgencyDispositions
